var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayReleaseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.938,
    height: 19.98,
    viewBox: "0 0 30.938 19.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(-213 -484.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_4",
    "data-name": "Exclusion 4",
    d: "M532.938-1029.79H506a2,2,0,0,1-2-2v-15.98a2,2,0,0,1,2-2h26.938a2,2,0,0,1,2,2v15.98A2,2,0,0,1,532.938-1029.79Zm-18.955-6.865h0a3.887,3.887,0,0,0,1.119,2.8,4.639,4.639,0,0,0,2.435,1.026v1.623h1.309v-1.623a4.445,4.445,0,0,0,2.983-1.058,3.268,3.268,0,0,0,1.109-2.5,3.915,3.915,0,0,0-.246-1.354,3.513,3.513,0,0,0-.882-1.284,5.937,5.937,0,0,0-1.7-1.1l-1.262-.566v-3.089c.715.08,1.13.611,1.234,1.577h2.291a3.144,3.144,0,0,0-.956-2.375,4.091,4.091,0,0,0-2.57-1.039v-.482h-1.309v.482a3.749,3.749,0,0,0-2.421,1.03,2.982,2.982,0,0,0-.919,2.19,3.118,3.118,0,0,0,.687,1.943,7.282,7.282,0,0,0,2.653,1.8v3.933a1.593,1.593,0,0,1-.937-.64,1.949,1.949,0,0,1-.334-1.132c0-.029,0-.074.009-.148Zm4.894,2h-.032v-3.452c1.213.469,1.828,1.115,1.828,1.921a1.4,1.4,0,0,1-.516,1.085A1.868,1.868,0,0,1,518.877-1034.651Zm-1.341-6.643h0c-.694-.412-1.046-.88-1.046-1.391,0-.6.352-.965,1.048-1.094v2.486Z",
    transform: "translate(-291 1534)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayReleaseIcon);
export default __webpack_public_path__ + "static/media/payReleaseIcon.aea75d7c23f3e6878761a66307182014.svg";
export { ForwardRef as ReactComponent };